/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { FormattedMessage } from 'react-intl';

const POS = {
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BTM: 'btm',
};

export const IconButton = ({ onClick, icon }) => (
  <span className="icon-button" onClick={onClick} role="button" tabIndex="0">
    <i className={icon} aria-hidden="true" />
  </span>
);

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
};

const cssPositionClass = (pos) => {
  switch (pos) {
    case POS.RIGHT:
      return 'pull-right';
    case POS.LEFT:
      return 'pull-left';
    default:
      return '';
  }
};

// DEPRECATED: Inline, and replace with prime react
export const DeleteTextButton = ({
  onClick, styleClass, text, position, size,
}) => {
  const posStyle = cssPositionClass(position);
  const sizeStyle = size || 'btn-sm';
  const style = `${styleClass || 'p-button-danger p-button-sm ghost-danger-button'} ${sizeStyle} ${posStyle}`;
  return <Button type="button" className={style} onClick={onClick} label={text} style={{ marginLeft: '5px' }} />;
};

DeleteTextButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  styleClass: PropTypes.string,
  text: PropTypes.string,
  position: PropTypes.string,
  size: PropTypes.string,
};

DeleteTextButton.defaultProps = {
  styleClass: '',
  text: '',
  position: '',
  size: '',
};

export const PreviewButton = ({
  textVariables, onClick, position, styleClass, size,
}) => {
  const sizeStyle = size || 'btn-sm';
  const posStyle = cssPositionClass(position);
  const style = `${styleClass || 'btn btn-primary'} ${sizeStyle} ${posStyle}`;
  return (
    <FormattedMessage id="assessment.preview" defaultMessage="Preview" values={textVariables}>
      {text => <Button type="button" label={text} className={style} onClick={onClick} />}
    </FormattedMessage>
  );
};

PreviewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  styleClass: PropTypes.string,
  position: PropTypes.string,
  size: PropTypes.string,
  textVariables: PropTypes.objectOf(PropTypes.any),
};

PreviewButton.defaultProps = {
  styleClass: '',
  position: '',
  size: '',
  textVariables: {},
};
